export const Employee = [
    {
        name:'Samanta Grey',
        img:'https://imagenes.expreso.ec/files/image_800_600/files/fp/uploads/2021/02/19/602fa2c3a0b97.r_d.1949-1628-0.jpeg',
        position:'Founder & CEO',
        animation:'fade-left'
    },
    {
        name:'Bruce Sutton',
        img:'https://itechus.com/wp-content/uploads/2017/11/555-5.jpg',
        position:'Sales & Marketing Manager',
        animation:'fade-up'
    },
    {
        name:'Janet Joy',
        img:'https://thumbs.dreamstime.com/b/portrait-smiling-professional-girl-pointing-herself-self-promoting-talking-personal-achievement-standing-casual-212893344.jpg',
        position:'Product Manager ',
        animation:'fade-down'
    },
    {
        name:'Mark Pocket',
        img:'https://i.pinimg.com/originals/3f/c9/33/3fc933521b2d080563f3748406d1a0ee.jpg',
        position:'Product Manager',
        animation:'fade-left'
    },
    {
        name:'Jonadon Doe',
        img:'https://thumbs.dreamstime.com/b/ready-start-working-today-devoted-energized-professional-girl-photographer-cross-arms-chest-confident-assertive-smiling-broadly-157890798.jpg',
        position:'HR Manager',
        animation:'fade-right'
    },
    {
        name:'Taleba Banu',
        img:'https://grabit.com.pk/Images/DealGallery/Toni-sonsdeal01-small17484343551086.png',
        position:'Sales & Marketing',
        animation:'fade-left'
    },
    {
        name:'Komola Shundory',
        img:'http://img-cdn.tid.al/o/07cf64d4e5790d74103878afd4ca0f7ecc9a5adb.jpg',
        position:'Graphics Designer',
        animation:'fade-up'
    },
    {
        name:'Jhon Sinha',
        img:'https://images.statusfacebook.com/profile_pictures/stylish-boys/boys-profile-pics-319.jpg',
        position:'Freelancer',
        animation:'fade-down'
    },
]